const provincias = () => {
    const provincia = document.querySelector<HTMLSelectElement>('[name$="[provincia]"]'),
        comunidad = document.querySelector<HTMLSelectElement>('[name$="[ccaa]"]'),
        cp = document.querySelector<HTMLInputElement>('[name$="[cp]"]');

    if (!provincia || !comunidad) return;

    const labelProvincia = document.querySelector<HTMLLabelElement>('[for="' + provincia.id + '"]');
    if (labelProvincia) {
        labelProvincia.classList.remove('is-inactiva');
    }

    const cps = {
            '01': 'Álava',
            '02': 'Albacete',
            '03': 'Alicante',
            '04': 'Almería',
            '05': 'Ávila',
            '06': 'Badajoz',
            '07': 'Baleares',
            '08': 'Barcelona',
            '09': 'Burgos',
            '10': 'Cáceres',
            '11': 'Cádiz',
            '12': 'Castellón',
            '13': 'Ciudad Real',
            '14': 'Córdoba',
            '15': 'La Coruña',
            '16': 'Cuenca',
            '17': 'Gerona',
            '18': 'Granada',
            '19': 'Guadalajara',
            '20': 'Guipúzcoa',
            '21': 'Huelva',
            '22': 'Huesca',
            '23': 'Jaén',
            '24': 'León',
            '25': 'Lérida',
            '26': 'La Rioja',
            '27': 'Lugo',
            '28': 'Madrid',
            '29': 'Málaga',
            '30': 'Murcia',
            '31': 'Navarra',
            '32': 'Orense',
            '33': 'Asturias',
            '34': 'Palencia',
            '35': 'Las Palmas',
            '36': 'Pontevedra',
            '37': 'Salamanca',
            '38': 'Santa Cruz de Tenerife',
            '39': 'Cantabria',
            '40': 'Segovia',
            '41': 'Sevilla',
            '42': 'Soria',
            '43': 'Tarragona',
            '44': 'Teruel',
            '45': 'Toledo',
            '46': 'Valencia',
            '47': 'Valladolid',
            '48': 'Vizcaya',
            '49': 'Zamora',
            '50': 'Zaragoza',
            '51': 'Ceuta',
            '52': 'Melilla'
        } as { [key: string]: string },
        comunidades = {
            "Andalucía": ['Almería', 'Cádiz', 'Córdoba', 'Granada', 'Huelva', 'Jaén', 'Málaga', 'Sevilla'],
            "Aragón": ['Huesca', 'Teruel', 'Zaragoza'],
            "Asturias, Principado de": ['Asturias'],
            "Balears, Illes": ['Baleares'],
            "Canarias": ['Las Palmas', 'Santa Cruz de Tenerife'],
            "Cantabria": ['Cantabria'],
            "Castilla y León": ['Ávila', 'Burgos', 'León', 'Palencia', 'Salamanca', 'Segovia', 'Soria', 'Valladolid', 'Zamora'],
            "Castilla - La Mancha": ['Albacete', 'Ciudad Real', 'Cuenca', 'Guadalajara', 'Toledo'],
            "Cataluña": ['Barcelona', 'Girona', 'Lérida', 'Tarragona'],
            "Comunitat Valenciana": ['Alicante', 'Castellón', 'Valencia'],
            "Extremadura": ['Badajoz', 'Cáceres'],
            "Galicia": ['A Coruña', 'Lugo', 'Ourense', 'Pontevedra'],
            "Madrid, Comunidad de": ['Madrid'],
            "Murcia, Región de": ['Murcia'],
            "Navarra, Comunidad Foral de": ['Navarra'],
            "País Vasco": ['Álava', 'Guipúzcoa', 'Vizcaya'],
            "Rioja, La": ['La Rioja'],
            "Ceuta": ['Ceuta'],
            "Melilla": ['Melilla']
        } as { [key: string]: string[] },
        actualizaProvincias = () => {
            if (comunidades[comunidad.value]) {
                const provincias = comunidades[comunidad.value];
                let html = '';

                provincia.disabled = false;
                if (provincias.length !== 1) {
                    html = '<option value="">---</option>';
                }

                provincia.innerHTML = html + provincias.map(provincia => `<option value="${provincia}">${provincia}</option>`).join('');
            } else {
                provincia.disabled = true;
                provincia.innerHTML = '<option value="">Selecciona una comunidad</option>';
            }
        };

    comunidad.addEventListener('change', actualizaProvincias);
    actualizaProvincias();

    if (cp) {
        cp.addEventListener('keyup', () => {
            if (cp.value.length < 5) return;

            const codigo = cp.value.substr(0, 2);

            if (cps[codigo]) {
                comunidad.value = Object.keys(comunidades).find(x => comunidades[x].includes(cps[codigo])) || '';
                actualizaProvincias();
                provincia.value = cps[codigo];
            }
        });
    }
}

export default provincias;